import { create } from 'zustand'

interface TermsAndConditionsState {
    termsAccepted: boolean
    acceptTerms: () => void
    resetTermsAndConditions: () => void

}

export const useTermsAndConditionsStore = create<TermsAndConditionsState>((set, get) => ({
    termsAccepted: false,
    acceptTerms: () => set({ termsAccepted: true }),
    resetTermsAndConditions: () => set({ termsAccepted: false }),
}))

